export default {
    static: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/image/state.js